import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, useIntl, FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Helmet } from '@plone/volto/helpers/Helmet/Helmet';
import { usePrevious } from '@plone/volto/helpers/Utils/usePrevious';
import { default as Toast } from '@plone/volto/components/manage/Toast/Toast';
import { Form } from '@plone/volto/components/manage/Form';
// import { getUserSchema } from '@plone/volto/actions/userschema/userschema';
import { createUser } from '@plone/volto/actions/users/users';
import Captcha from 'volto-form-block/components/Widget/Captcha';

import { Header, Container } from 'semantic-ui-react';
import { isValidForm } from '../captcha_utils';
import { getRecaptcha } from '../../actions/recaptcha/recaptcha';
import { getRegistrationUserschema } from '../../actions/registration_userschema/registration_userschema';

const messages = defineMessages({
  title: {
    id: 'Registration form',
    defaultMessage: 'Registration form',
  },
  successRegisterCompletedTitle: {
    id: 'Account Registration Completed',
    defaultMessage: 'Account Registration Completed',
  },
  successRegisterCompletedBody: {
    id: 'The registration process has been successful. Please check your e-mail inbox for information on how activate your account.',
    defaultMessage:
      'The registration process has been successful. Please check your e-mail inbox for information on how activate your account.',
  },
  register: {
    id: 'Register',
    defaultMessage: 'Register',
  },
  welcome: {
    id: 'Welcome!',
    defaultMessage: 'Welcome!',
  },
});
const useUsers = () => {
  const error = useSelector((state) => state.users.create.error);
  const loading = useSelector((state) => state.users.create.loading);
  const loaded = useSelector((state) => state.users.create.loaded);
  return {
    error,
    loaded,
    loading,
  };
};
const Register = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const history = useHistory();
  const [errors, setError] = useState(null);
  const [formErrors, setFormErrors] = useState([]);
  const { loaded, loading, error } = useUsers();

  const prevloading = usePrevious(loading);
  const userschema = useSelector((state) => state.registration_userschema);
  const recaptcha = useSelector((state) => state.recaptcha);

  useEffect(() => {
    dispatch(getRecaptcha());
  }, [dispatch]);
  useEffect(() => {
    if (!userschema.loading && !userschema.loaded) {
      dispatch(getRegistrationUserschema());
    }
  }, [userschema, dispatch]);

  useEffect(() => {
    if (prevloading && loaded) {
      toast.success(
        <Toast
          success
          title={intl.formatMessage(messages.successRegisterCompletedTitle)}
          content={intl.formatMessage(messages.successRegisterCompletedBody)}
        />,
      );
      // history.push('/login');
    }
  }, [intl, history, loaded, prevloading]);

  const captchaToken = useRef();
  const getErrorMessage = (field) => {
    const e = formErrors?.filter((e) => e.field === field);
    return e.length > 0 ? e[0].message : null;
  };
  const captcha = new Captcha({
    captchaToken,
    captcha: 'recaptcha',
    captcha_props: {
      provider: 'recaptcha',
      public_key: recaptcha.data?.site_key,
    },
    errorMessage: getErrorMessage('captcha'),
  });
  const onSubmit = (data) => {
    captcha
      .verify()
      .then(() => {
        if (isValidForm(data, captchaToken, setFormErrors, intl)) {
          dispatch(
            createUser({
              ...data,
              captcha: { provider: 'recaptcha', token: captchaToken.current },
            }),
          );
          setError(null);
        }
      })
      .catch(() => {
        // eslint-disable-next-line no-console
        console.error('Captcha verification error');
      });
  };

  const emptySchema = {
    fieldsets: [],
    properties: {},
    required: [],
  };

  return (
    <div id="page-register">
      <Helmet title={intl.formatMessage(messages.register)} />
      {prevloading && loaded ? (
        <Container>
          <Header as="h1" className="no-breadcrumb">
            {intl.formatMessage(messages.successRegisterCompletedTitle)}
          </Header>
          <p>{intl.formatMessage(messages.successRegisterCompletedBody)}</p>
        </Container>
      ) : (
        <div className="register-container">
          <h1>
            <FormattedMessage
              id="register page heading"
              defaultMessage="Regístrate para ver información completa sobre las localizaciones"
            />
          </h1>
          <p className="fbc-description ">
            <FormattedMessage
              id="register page description"
              defaultMessage="Si estás interesado en rodar en el País Vasco, crea una cuenta
            gratuita para acceder a nuestra área privada de localizaciones
            rellenando el siguiente formulario."
            />
          </p>
          {recaptcha.loaded && captcha.render()}

          <Form
            onSubmit={onSubmit}
            // title={intl.formatMessage(messages.title)}
            error={
              errors || error?.response?.body?.error || error?.response?.body
            }
            loading={loading}
            submitLabel={intl.formatMessage(messages.register)}
            schema={
              userschema.loaded
                ? {
                    ...userschema.userschema,
                    properties: {
                      ...userschema.userschema.properties,
                      captcha: {
                        title: 'recaptcha',
                        widget: 'captcha',
                        captcha: 'recaptcha',
                        captcha_props: {
                          provider: 'recaptcha',
                          public_key: recaptcha.data?.site_key,
                        },
                      },
                    },
                    // fieldsets: [
                    //   {
                    //     ...userschema.userschema.fieldsets[0],
                    //     fields: [
                    //       ...userschema.userschema.fieldsets[0].fields,
                    //       'captcha',
                    //     ],
                    //   },
                    // ],
                  }
                : emptySchema
            }
          />
        </div>
      )}
    </div>
  );
};

export default Register;
